module.exports = __webpack_public_path__ + "static/img/042_1.c953d13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/042_1.jpg
// module id = 5tL1
// module chunks = 1